import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  container: {
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    backgroundColor: "#ffffff",
    opacity: 0.5,
    textAlign: "center"
  },
  progress: {
    display: "inline-block"
  },
  progressWrapper: {
    position: "relative",
    top: "50%",
    transform: "translateY(-50%)"
  }
});

function RootLoading(props) {
  const { classes, visible, text } = props;
  if (!visible) return null;
  return (
    <div className={classes.container}>
      <div className={classes.progressWrapper}>
        <CircularProgress className={classes.progress} size={50} />
        {text && <Typography variant="headline">{text}</Typography>}
      </div>
    </div>
  );
}

export default withStyles(styles)(RootLoading);
